"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateQualificationExperienceDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
class CreateQualificationExperienceDto {
}
exports.CreateQualificationExperienceDto = CreateQualificationExperienceDto;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(100, {
        message: "Name of qualification must not exceed 100 characters",
    }),
    tslib_1.__metadata("design:type", String)
], CreateQualificationExperienceDto.prototype, "nameOfQualification", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(1900, { message: "Year of qualification must be 1900 or later" }),
    (0, class_validator_1.Max)(new Date().getFullYear(), {
        message: "Year of qualification cannot be in the future",
    }),
    tslib_1.__metadata("design:type", Number)
], CreateQualificationExperienceDto.prototype, "yearOfQualification", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Details must be a string" }),
    (0, class_validator_1.MaxLength)(500, { message: "Details must not exceed 500 characters" }),
    tslib_1.__metadata("design:type", String)
], CreateQualificationExperienceDto.prototype, "details", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "University Name must be a string" }),
    (0, class_validator_1.MaxLength)(100, { message: "University Name must not exceed 100 characters" }),
    tslib_1.__metadata("design:type", String)
], CreateQualificationExperienceDto.prototype, "universityName", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateQualificationExperienceDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateQualificationExperienceDto.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], CreateQualificationExperienceDto.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], CreateQualificationExperienceDto.prototype, "updatedAt", void 0);
